<form [formGroup]="form" class="medium scrollbar-gray">
  <p-fluid class="inputs-section w100">
    <div class="field-double mb-16 w100">
      <div class="col w100">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.company-name' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="legalName"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-name' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="field-double mb-16">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.account-name' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="name"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-name' | translate }}"
          type="text"
        />
      </div>

      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.contact-name' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="contactName"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-name' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="field-double mb-16">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.email' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="email"
          pInputText
          placeholder="email@telematics.com"
          type="text"
        />
      </div>

      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.phone-number' | translate }}
        </div>

        <app-phone-number-input
          #phoneNumberInput
          [defaultCountryCode]="TYPES.CountryCodes.UnitedStates"
          formControlName="phone"
        ></app-phone-number-input>
      </div>
    </div>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.input-label.country' | translate }}
      <span class="required">*</span>
    </div>

    @let countryOptions =
      (countryOptions$ | async) ?? (countyOptionsProvider.allCountryOptions$ | async) ?? [];
    <app-autocomplete-select
      (completeMethod)="onCountrySearch($event)"
      [completeOnFocus]="true"
      [forceSelection]="true"
      [suggestions]="countryOptions"
      className="mb-16"
      formControlName="country"
      optionLabel="label"
      optionValue="value"
    ></app-autocomplete-select>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.input-label.address' | translate }}
    </div>

    <div class="field-double mb-12">
      <div class="col">
        <input
          class="h--40"
          formControlName="address"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.street-address' | translate }}"
          type="text"
        />
      </div>

      <div class="col">
        <input
          class="h--40"
          formControlName="city"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.city' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="field-double mb-16">
      <div class="col">
        <input
          class="h--40"
          formControlName="region"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.state-region' | translate }}"
          type="text"
        />
      </div>

      <div class="col">
        <input
          class="h--40"
          formControlName="zipCode"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.postal-code-zip' | translate }}"
          type="text"
        />
      </div>
    </div>

    @if (isInCreateMode) {
      <div class="label mb-8 text-14 fw-500">
        {{ 'ti-admin.accounts.form.input-label.billing-mode' | translate }}
      </div>

      <p-select
        [options]="(billingModeOptions$ | async) || []"
        appendTo="body"
        class="h--40 w100 mb-16"
        formControlName="billingMode"
      >
        <ng-template let-param pTemplate="item">
          <div class="option-item text-14">
            <div>{{ param.label }}</div>
          </div>
        </ng-template>
      </p-select>
    }

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.input-label.username-prefix' | translate }}
    </div>

    <div class="col w100">
      <input
        class="h--40 mb-8 w100"
        formControlName="usernamePrefix"
        pInputText
        placeholder="{{ 'ti-admin.accounts.form.input-placeholder.username-prefix' | translate }}"
        type="text"
      />
    </div>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.input-label.billing-start-date' | translate }}
    </div>

    <div class="field-double mb-16 fw-500">
      <app-date-range-picker-dialog
        (dateRangeChange)="updateBillingStartDate($event)"
        [checkOnPreDefined]="false"
        [dateRange]="$any([form.value.billingStartDate, form.value.billingStartDate])"
        [hideDateRange]="true"
        [showPreDefined]="false"
        [singleDay]="true"
        [useInput]="true"
        class="fw-500 w100"
      ></app-date-range-picker-dialog>

      @if (form.value.billingStartDate) {
        <p-button
          (click)="removeBillingStartDate()"
          [severity]="'secondary'"
          class="h--40"
          icon="pi"
        >
          <app-icon-close
            [color]="'var(--color-alert-500)'"
            [height]="20"
            [width]="20"
            class="icon"
          ></app-icon-close>
        </p-button>
      }
    </div>

    <div class="horizontal-spacer--16"></div>

    <div class="field-double mb-16 w100">
      <div class="flex align-items-center col">
        <p-checkbox [binary]="true" formControlName="tntPlan" inputId="tntPlan"></p-checkbox>
        <label [for]="'tntPlan'" class="label-primary ml-12 text-14 fw-400 color-gray-900">
          {{ 'common.pricing-plans.0' | translate }}
        </label>
      </div>

      <div class="flex align-items-center col">
        <p-checkbox
          [binary]="true"
          formControlName="standardPlan"
          inputId="standardPlan"
        ></p-checkbox>
        <label [for]="'standardPlan'" class="label-primary ml-12 text-14 fw-400 color-gray-900">
          {{ 'common.pricing-plans.1' | translate }}
        </label>
      </div>
    </div>
    <div class="field-double mb-16 w100">
      <div class="flex align-items-center col">
        <p-checkbox
          [binary]="true"
          formControlName="advancedPlan"
          inputId="advancedPlan"
        ></p-checkbox>
        <label [for]="'advancedPlan'" class="label-primary ml-12 text-14 fw-400 color-gray-900">
          {{ 'common.pricing-plans.2' | translate }}
        </label>
      </div>

      <div class="flex align-items-center col">
        <p-checkbox
          [binary]="true"
          formControlName="premiumPlan"
          inputId="premiumPlan"
        ></p-checkbox>
        <label [for]="'premiumPlan'" class="label-primary ml-12 text-14 fw-400 color-gray-900">
          {{ 'common.pricing-plans.3' | translate }}
        </label>
      </div>
    </div>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.telemetry-devices-pricing' | translate }}
    </div>
    <div class="horizontal-spacer--16"></div>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.input-label.minimum-monthly-fee' | translate }}
    </div>
    <p-input-number
      class="h--40 mb-16"
      formControlName="minimumMonthlyFee"
      inputmode="numeric"
      [min]="0"
      placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
      [step]="1"
      type="number"
    />

    <div class="field-double mb-16 w100">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.tnt-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="tntDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.standard-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="standardDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="field-double mb-16 w100">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.advanced-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="advancedDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.premium-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="premiumDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="label mb-8 text-14 fw-500">
      {{ 'ti-admin.accounts.form.media-devices-pricing' | translate }}
    </div>
    <div class="horizontal-spacer--16"></div>
    <div class="field-double mb-16 w100">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.standard-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="standardMediaDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>

      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.advanced-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="advancedMediaDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
    </div>
    <div class="field-double mb-16 w100">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'ti-admin.accounts.form.input-label.premium-device-price' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          formControlName="premiumMediaDevicePrice"
          pInputText
          placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
          type="text"
        />
      </div>
    </div>

    <div class="horizontal-spacer--16"></div>

    @if (this.form.value.billingMode === BillingMode.Monthly) {
      <div class="field-double mb-16 w100">
        <div class="col">
          <div class="label mb-8 text-14 fw-500">
            {{ 'ti-admin.accounts.form.input-label.extra-telemetry-price' | translate }}
            <span class="required">*</span>
          </div>
          <input
            class="h--40"
            formControlName="extraTelemetryPrice"
            pInputText
            placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
            type="text"
          />
        </div>
        <div class="col">
          <div class="label mb-8 text-14 fw-500">
            {{ 'ti-admin.accounts.form.input-label.extra-storage-price' | translate }}
            <span class="required">*</span>
          </div>
          <input
            class="h--40"
            formControlName="extraStoragePrice"
            pInputText
            placeholder="{{ 'ti-admin.accounts.form.input-placeholder.enter-price' | translate }}"
            type="text"
          />
        </div>
      </div>
    } @else {
      <div class="field-double mb-16 w100">
        <div class="col full-width mb-16">
          <div class="label label-info mb-8 text-14 fw-500">
            <div>
              {{ 'ti-admin.accounts.form.input-label.telemetry-history' | translate }}
            </div>
          </div>
          <div class="field">
            <p-select
              [options]="(dataHistoryOptions$ | async) ?? []"
              appendTo="body"
              class="h--40"
              formControlName="telemetryHistory"
            >
              <ng-template let-param pTemplate="selecteditem">
                <div class="option-item text-14">
                  <div>{{ param.label }}</div>
                </div>
              </ng-template>
              <ng-template let-param pTemplate="item">
                <div class="option-item text-14">
                  <div>
                    {{ param.label }}
                    @if (param.value === DEFAULT_DATA_HISTORY_MONTH) {
                      ({{ 'ti-admin.accounts.data-history.default' | translate }})
                    }
                  </div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>

        <div class="col">
          <!-- media storage setting -->
          <div class="label label-info mb-8 text-14 fw-500">
            <div>
              {{ 'ti-admin.accounts.form.input-label.storage-size' | translate }}
            </div>
          </div>

          <p-select
            [options]="mediaStorageOptions"
            appendTo="body"
            class="h--40 mb-4"
            formControlName="storageSize"
            optionLabel="name"
            optionValue="value"
          >
            <ng-template let-param pTemplate="item">
              <div class="option-item text-14">
                <div>{{ param.name }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    }

    <section #errorBlock [class.hidden]="!errorMessage" class="errors-section">
      <div class="errors-section-icon">
        <i class="pi pi-times-circle"></i>
      </div>
      <div class="text-14">
        {{ errorMessage | translate: { accountName: account.name, name: account.name } }}
      </div>
    </section>
  </p-fluid>
</form>

<div class="footer border-top flex">
  <p-button
    (click)="onCancel()"
    [disabled]="!!(disableMode$ | async)"
    [severity]="'secondary'"
    class="cancel text-14 fw-600 w50 p--8 h--40"
    type="submit"
  >
    {{ 'button.cancel' | translate }}
  </p-button>

  <p-button
    (click)="onSubmit()"
    [disabled]="!modelWasChanged || form.invalid || processing"
    [loading]="isLoading"
    class="submit text-14 fw-600 w50 h--40"
    type="submit"
  >
    @switch (isInCreateMode) {
      @case (true) {
        <app-icon-launch
          [color]="'var(--color-gray-0)'"
          [height]="20"
          [width]="20"
          class="icon"
        ></app-icon-launch>
        {{ 'button.launch' | translate }}
      }
      @case (false) {
        <app-icon-check [height]="20" [width]="20" class="icon"></app-icon-check>
        {{ 'button.save' | translate }}
      }
    }
  </p-button>
</div>
